import React, { useState,useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Menu, MenuItem, Avatar, Box, Tooltip, Container, ListItemIcon, ListItemText} from '@mui/material';
import TLS_Logo from '../images/trueleasing_logo.png';
import { Menu as MenuIcon,} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { Us, Th, Cn } from "react-flags-select";

const ResponsiveAppBar = () => {
  const { t } = useTranslation('booking_appbar');
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [fullName, setFullName] = useState('ชื่อจริง นามสกุล');
  const [language,setLanguage] = useState('')
  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleCloseNavMenu = () => setAnchorElNav(null);
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  useEffect(() => {
    const name = Cookies.get('first_name') + ' ' + Cookies.get('last_name');
    setFullName(name)
    const language = Cookies.get('language') || "TH"
    setLanguage(language)
    i18next.changeLanguage(language);
  }, [fullName]);

  const handleLogout = () => {
    Cookies.remove('token');
    Cookies.remove('first_name');
    Cookies.remove('last_name');
    navigate('/login');
  };

  const pages = [
    { title: t('booking'), path: '/' },
    { title: t('private'), path: 'https://trueleasing.co.th/th/hackercraftboat' },
    { title: t('service'), path: 'https://trueleasing.co.th/th/pages/our-boats' },
    { title: t('place'), path: 'https://trueleasing.co.th/th/wheretogo/5?travelBy=0' },
    { title: t('about'), path: 'https://trueleasing.co.th/en/pages/TheWonderBlueAyutthaya' },
  ];

  const handleChangeLanguage = (data) => {

    setLanguage(data);
    Cookies.set('language',data)
    i18next.changeLanguage(data);
    handleCloseUserMenu(); //
  }


  return (
    <AppBar position="static" sx={{ backgroundColor: 'white', color: 'black', position:'fixed', left:'0', top:'0', zIndex:'999' }}>
      <Container maxWidth="xl" sx={{border:'0px solid #f00', betweenContent:'justify', width:'100%'}}>
        <Toolbar disableGutters>

          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
          >
            <img
              src={TLS_Logo}
              alt="Logo"
              style={{ height: '65px', margin: '15px 50px 15px 50px' }}
            />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page.title} onClick={handleCloseNavMenu} component={Link} to={page.path}>
                  <Typography textAlign="center">{page.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
          >
            <img
              src={TLS_Logo}
              alt="Logo"
              style={{ height: '60px' }}
            />
          </Typography>
          
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.title}
                component={Link}
                to={page.path}
                sx={{
                  fontSize:'17px',
                  fontWeight:'300',
                  marginRight:'30px',
                  marginTop:'15px',
                  // my: 2,
                  color: 'black',
                  display: 'block',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255)',
                    color:'#f00',
                    borderBottom: '0px solid #1976d2'
                  }
                }}
              >
                {page.title}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Switch language">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 3}}>
                <Avatar alt="EN" sx={{fontSize:'14px', fontWeight:'bold'}}>{language}</Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '75px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              PaperProps={{
                style: {
                  width: '150px',
                  backgroundColor: 'grey.900',
                  color: 'black',
                },
              }}
            >             
              <MenuItem onClick={(e)=>handleChangeLanguage('EN')}>
                <ListItemIcon>
                  <Us sx={{ color:  'black' }} />
                </ListItemIcon>
                <ListItemText primary="English" />
              </MenuItem>

              <MenuItem onClick={(e)=>handleChangeLanguage('TH')}>
                <ListItemIcon>
                  <Th sx={{ color:  'black' }} />
                </ListItemIcon>
                <ListItemText primary="ภาษาไทย" />
              </MenuItem>

              {/* <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Cn sx={{ color:  'black' }} />
                </ListItemIcon>
                <ListItemText primary="China" />
              </MenuItem> */}

            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;